export const getEnvironment = (): string | undefined => {
  const env = window.location.hostname.split('.');

  // env[1] === 'prizepicks' is used to identify the production environment
  if (
    env &&
    env.length > 1 &&
    ['development', 'staging', 'prizepicks'].includes(env[1])
  ) {
    return env[1] === 'prizepicks' ? 'production' : env[1];
  }

  return undefined;
};
